<div class="pricing">
  <div class="header">
    <app-navbar></app-navbar>
    <app-pricing-header></app-pricing-header>
  </div>
  <app-pricing-component></app-pricing-component>
  <app-footer></app-footer>
</div>
